export const OPERATIONS_HUB_PAGE_CONFIG = {
  blocked: {
    title: 'Blocked Vehicles',
    description: 'Manage and monitor all vehicles with active or resolved blocks.',
  },
  arbitration: {
    title: 'Arbitration Management',
    description: 'Manage and track arbitration cases across vehicles',
  },
  'due-bill': {
    title: 'Due Bill Management',
    description: 'Manage and track due bills for all vehicles',
  },
  goodwill: {
    title: 'Goodwill Management',
    description: 'Track goodwill cases, decisions, and applied adjustments',
  },
  'frontline-requests': {
    title: 'Frontline Requests Management',
    description: 'Manage and track all frontline requests ',
  },
} as const

// Copy for the select-vehicle modal on the due bill / goodwill pages, where only sold
// vehicles (F&I or Sold tabs) are eligible.
export const SOLD_VEHICLE_SELECT_COPY = {
  title: 'Select a Sold Vehicle',
  description: 'Search and choose a sold vehicle to continue.',
} as const

/**
 * Empty-state copy for the vehicle search dropdown. The due bill / good will
 * eligible-vehicles endpoint returns flags alongside an empty `data` saying why the match
 * isn't selectable (see ReconVehicleSearchResponse); everything else falls back to
 * `noResults`.
 */
export const VEHICLE_SEARCH_EMPTY_COPY = {
  noResults: 'No Results Found',
  notSold: 'The vehicle cannot be located in either the F&I or Sold tabs.',
  hasDueBill: 'The vehicle already has a due bill.',
  hasActiveGoodwill: 'The vehicle already has an active Goodwill',
} as const

export type OperationsHubTab = keyof typeof OPERATIONS_HUB_PAGE_CONFIG

export const OPERATIONS_HUB_TABS: { key: OperationsHubTab; label: string }[] = [
  { key: 'blocked', label: 'Blocked' },
  { key: 'arbitration', label: 'Arbitration' },
  { key: 'due-bill', label: 'Due Bill' },
  { key: 'goodwill', label: 'Goodwill' },
  { key: 'frontline-requests', label: 'Frontline Requests' },
]
